var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return ((_vm.price))?_c('div',{staticClass:"crossed-price-container",style:(_vm._f("transRpxStyle")([({color: '#CCCCCC'})]))},[((_vm.prefix))?_c('span',[_vm._v(_vm._s(_vm.prefix))]):_vm._e(),_c('span',{staticClass:"price"},[_vm._v("￥"+_vm._s(_vm.price))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }